<div class="smart-template-builder-container">
    <!-- Header Section -->
    <div class="builder-header">
        <div class="header-content">
            <h2 class="builder-title">
                <mat-icon>auto_awesome</mat-icon>
                {{ editMode ? 'Editare Smart Template' : 'Creare Smart Template' }}
            </h2>
            <p class="builder-subtitle">
                Creează template-uri inteligente cu părți reutilizabile și parametri dinamici
            </p>
        </div>
        <div class="header-actions">
            <button mat-stroked-button (click)="previewTemplate()"
                [disabled]="!templateGroup.name || templateParts.length === 0">
                <mat-icon>visibility</mat-icon>
                Preview
            </button>
            <button mat-raised-button color="primary" (click)="saveTemplate()" [disabled]="!isFormValid() || isSaving">
                <mat-icon>save</mat-icon>
                {{ isSaving ? 'Se salvează...' : 'Salvează' }}
            </button>
        </div>
    </div>

    <!-- Main Content -->
    <div class="builder-content">
        <!-- Left Panel - Template Configuration -->
        <div class="left-panel">
            <mat-card class="config-card">
                <mat-card-header>
                    <mat-card-title>Configurare Template</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <!-- Basic Info -->
                    <div class="form-section">
                        <h3>Informații de bază</h3>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Nume template</mat-label>
                            <input matInput [(ngModel)]="templateGroup.name"
                                placeholder="Introduceti numele template-ului">
                            <mat-error *ngIf="!templateGroup.name">Numele este obligatoriu</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Descriere</mat-label>
                            <textarea matInput [(ngModel)]="templateGroup.description" rows="3"
                                placeholder="Descrierea template-ului (opțional)"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Categorie</mat-label>
                            <mat-select [(ngModel)]="templateGroup.category_id">
                                <mat-option value="">Selectează categoria</mat-option>
                                <mat-option *ngFor="let category of categories" [value]="category.id">
                                    {{ category.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="checkbox-group">
                            <mat-checkbox [(ngModel)]="templateGroup.is_active" color="primary">Template
                                activ</mat-checkbox>
                            <mat-checkbox [(ngModel)]="templateGroup.is_public" color="primary">Template
                                public</mat-checkbox>
                        </div>
                    </div>

                    <!-- Advanced Configuration -->
                    <div class="form-section">
                        <h3>Configurare avansată</h3>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Prioritate</mat-label>
                            <mat-select [(ngModel)]="templateGroup.priority">
                                <mat-option [value]="1">Scăzută</mat-option>
                                <mat-option [value]="2">Normală</mat-option>
                                <mat-option [value]="3">Ridicată</mat-option>
                                <mat-option [value]="4">Critică</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Tags (separate prin virgulă)</mat-label>
                            <input matInput [(ngModel)]="templateGroup.tags" placeholder="ex: cerere, evaluare, copil">
                        </mat-form-field>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Template Parameters -->
            <mat-card class="parameters-card">
                <mat-card-header class="d-flex align-items-center gap-2">
                    <mat-card-title>Parametri Template</mat-card-title>
                    <button mat-icon-button (click)="addParameter()">
                        <mat-icon>add</mat-icon>
                    </button>
                </mat-card-header>
                <mat-card-content>
                    <div class="parameters-list" *ngIf="templateParameters.length > 0">
                        <div class="parameter-item" *ngFor="let param of templateParameters; let i = index">
                            <div class="parameter-header">
                                <mat-form-field appearance="outline" class="param-name">
                                    <mat-label>Nume parametru</mat-label>
                                    <input matInput [(ngModel)]="param.name"
                                        placeholder="Introduceți numele parametrului">
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="param-type">
                                    <mat-label>Tip</mat-label>
                                    <mat-select [(ngModel)]="param.type">
                                        <mat-option value="text">Text</mat-option>
                                        <mat-option value="number">Număr</mat-option>
                                        <mat-option value="date">Dată</mat-option>
                                        <mat-option value="boolean">Da/Nu</mat-option>
                                        <mat-option value="select">Listă opțiuni</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button mat-icon-button color="warn" (click)="removeParameter(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                            <mat-form-field appearance="outline" class="full-width" *ngIf="param.type !== 'boolean'">
                                <mat-label>Valoare implicită</mat-label>
                                <input matInput [(ngModel)]="param.default_value"
                                    placeholder="Valoarea implicită (opțional)">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="full-width" *ngIf="param.type === 'select'">
                                <mat-label>Opțiuni (separate prin virgulă)</mat-label>
                                <input matInput [(ngModel)]="param.options"
                                    placeholder="Opțiunea 1, Opțiunea 2, Opțiunea 3">
                            </mat-form-field>

                            <mat-checkbox [(ngModel)]="param.is_required" color="primary">Parametru
                                obligatoriu</mat-checkbox>
                        </div>
                    </div>
                    <div class="empty-state" *ngIf="templateParameters.length === 0">
                        <mat-icon>settings</mat-icon>
                        <p>Nu există parametri definiți</p>
                        <button mat-stroked-button (click)="addParameter()">
                            <mat-icon class="mb-0">add</mat-icon>
                            Adaugă primul parametru
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Right Panel - Template Parts -->
        <div class="right-panel">
            <mat-card class="parts-card">
                <mat-card-header class="d-flex align-items-center gap-2">
                    <mat-card-title>Părți Template</mat-card-title>
                    <div class="parts-actions">
                        <button mat-icon-button [matMenuTriggerFor]="addMenu">
                            <mat-icon>add</mat-icon>
                        </button>
                        <mat-menu #addMenu="matMenu">
                            <button mat-menu-item (click)="addNewPart()">
                                <mat-icon>note_add</mat-icon>
                                <span>Parte nouă</span>
                            </button>
                            <button mat-menu-item (click)="addExistingPart()">
                                <mat-icon>library_add</mat-icon>
                                <span>Parte existentă</span>
                            </button>
                        </mat-menu>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <!-- Template Parts List -->
                    <div class="parts-list" cdkDropList (cdkDropListDropped)="onPartDrop($event)">
                        <div class="template-part" *ngFor="let part of templateParts; let i = index" cdkDrag
                            [class.expanded]="part.expanded">
                            <div class="part-header" (click)="togglePartExpansion(i)">
                                <div class="part-info">
                                    <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
                                    <div class="part-details">
                                        <span class="part-name">{{ part.name || 'Parte fără nume' }}</span>
                                        <span class="part-type">{{ getPartTypeLabel(part.type) }}</span>
                                    </div>
                                </div>
                                <div class="part-actions">
                                    <mat-icon class="expand-icon" [class.rotated]="part.expanded">expand_more</mat-icon>
                                    <button mat-icon-button (click)="duplicatePart(i); $event.stopPropagation()">
                                        <mat-icon>content_copy</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn"
                                        (click)="removePart(i); $event.stopPropagation()">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div class="part-content" *ngIf="part.expanded">
                                <div class="part-form">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Nume parte</mat-label>
                                        <input matInput [(ngModel)]="part.name" placeholder="Introduceti numele părții">
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="full-width">
                                        <mat-label>Tip parte</mat-label>
                                        <mat-select [(ngModel)]="part.type">
                                            <mat-option value="header">Header</mat-option>
                                            <mat-option value="content">Conținut</mat-option>
                                            <mat-option value="footer">Footer</mat-option>
                                            <mat-option value="signature">Semnătură</mat-option>
                                            <mat-option value="custom">Personalizat</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div class="content-editor">
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-label>Conținut HTML</mat-label>
                                            <textarea matInput [(ngModel)]="part.content" rows="8"
                                                placeholder="Introduceti conținutul HTML al părții...">
                      </textarea>
                                        </mat-form-field>
                                    </div>

                                    <div class="part-options">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Poziție</mat-label>
                                            <mat-select [(ngModel)]="part.position">
                                                <mat-option value="top">Sus</mat-option>
                                                <mat-option value="middle">Mijloc</mat-option>
                                                <mat-option value="bottom">Jos</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-checkbox [(ngModel)]="part.is_required" color="primary">Parte
                                            obligatorie</mat-checkbox>
                                        <mat-checkbox [(ngModel)]="part.is_repeatable" color="primary">Parte
                                            repetabilă</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Empty State -->
                    <div class="empty-state" *ngIf="templateParts.length === 0">
                        <mat-icon>view_module</mat-icon>
                        <p>Nu există părți definite pentru acest template</p>
                        <button mat-stroked-button (click)="addNewPart()">
                            <mat-icon class="mb-0">add</mat-icon>
                            Adaugă prima parte
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <!-- Preview Dialog -->
    <div class="preview-overlay" *ngIf="showPreview" (click)="closePreview()">
        <div class="preview-dialog" (click)="$event.stopPropagation()">
            <div class="preview-header">
                <h3>Preview Template</h3>
                <button mat-icon-button (click)="closePreview()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="preview-content">
                <div class="preview-document" [innerHTML]="previewHtml"></div>
            </div>
            <div class="preview-actions">
                <button mat-stroked-button (click)="closePreview()">Închide</button>
                <button mat-raised-button color="primary" (click)="exportPreview()">
                    <mat-icon>download</mat-icon>
                    Export PDF
                </button>
            </div>
        </div>
    </div>

    <div class="browser-footer">
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-secondary" (click)="onClose()">
                <i class="fas fa-times me-1"></i>
                Închide
            </button>
        </div>
    </div>
</div>